import { SET_EXCLUDE_ISO_APPENDIX } from "redux/types";

const setExcludeISOAppendix = (payload) => {
    return { type: SET_EXCLUDE_ISO_APPENDIX, payload };
};

export { setExcludeISOAppendix };
